<mfs-old-map
  [height]="'100%'"
  [zoom]="12"
  [drawingMode]="false"
  [showControls]="false"
  [showIndexControl]="false"
  [isCenterMarker]="false"
  [isCenterControl]="false"
  [parentPolygonJson]="field?.polygonJson"
  [multiPolygonJsonColors]="multiPolygonJson"
  [isLoading]="
  passportManager.isLoadingCrops() ||
  passportManager.isLoadingActiveSeasons() ||
  passportManager.isLoadingField()
"
/>
